"use client"

import type { ReactElement } from "react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import CourseSettingsModal from "@/components/course-material/modals/CourseSettingsModal"

import DropdownMenu from "../DropdownMenu"
import { useQuickActionsItems } from "./hooks/useQuickActionsItems"

interface MenuOption {
  type: "link" | "action" | "separator"
  label?: string
  href?: string
  onAction?: () => void
  icon?: ReactElement
  isDestructive?: boolean
}

interface QuickActionsMenuProps {
  menuOptions?: MenuOption[] | undefined
  courseId?: string | null | undefined
}

const QuickActionsMenu: React.FC<QuickActionsMenuProps> = ({ menuOptions, courseId }) => {
  const { t } = useTranslation()
  const [showCourseSettings, setShowCourseSettings] = useState(false)

  const { items, shouldShow } = useQuickActionsItems({
    menuOptions,
    courseId,
    onCourseSettingsOpen: () => {
      setShowCourseSettings(true)
    },
  })

  if (!shouldShow) {
    return null
  }

  return (
    <>
      {courseId && showCourseSettings && (
        <CourseSettingsModal
          onClose={() => {
            setShowCourseSettings(false)
          }}
          manualOpen={showCourseSettings}
        />
      )}
      <DropdownMenu
        // oxlint-disable-next-line i18next/no-literal-string
        menuTestId="topbar-quick-actions-menu"
        // oxlint-disable-next-line i18next/no-literal-string
        menuButtonTestId="topbar-quick-actions"
        items={items}
        navLabel={t("quick-actions")}
        controlButtonAriaLabel={t("open-quick-actions-menu")}
        controlButtonTooltipText={t("quick-actions")}
      />
    </>
  )
}

export default QuickActionsMenu
